export const getIsMobileWebView = (): boolean => {
  if (typeof window === 'undefined') return false;
  return Boolean((window as Window & { isReactNativeWebView?: boolean }).isReactNativeWebView);
};
